import { cn } from '@/lib/utils'
import { useHelpText } from './useHelpText'

/**
 * Always-visible explanation, used where the reader should not have to ask for it: the
 * description of the variant currently selected in one of the wizard's polymorphic dropdowns,
 * and the few section-level hints. Same source and same empty-means-nothing rule as
 * `HelpHint`, so the two can never drift apart in styling or behaviour.
 */
export function HelpText({ helpKey, className }: { helpKey: string; className?: string }) {
  const text = useHelpText(helpKey)
  if (!text) return null

  return <p className={cn('text-sm text-muted-foreground', className)}>{text}</p>
}
